import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Vuetify from "vuetify/lib";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);
Vue.use(VueSweetalert2);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: "pt",
  },
});
